export const PHONE_REGEX = /^1[3-9]\d{9}$/
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export function getLoginIdentifierValidationError(value?: string | null) {
  const trimmedValue = `${value || ''}`.trim()

  if (!trimmedValue) {
    return 'empty'
  }

  if (PHONE_REGEX.test(trimmedValue) || EMAIL_REGEX.test(trimmedValue)) {
    return null
  }

  return 'invalid'
}

export function isValidLoginIdentifier(value?: string | null) {
  return getLoginIdentifierValidationError(value) === null
}
